export default __webpack_public_path__ + "static/media/endVacancy.7cfd0928.png";